<template lang="pug">
v-dialog(v-model="dialog" dark max-width="800px")
  v-card(outlined dark)
    v-card-title Выберите заявки, которые желаете добавить в группу
    v-card-text
      smart-table(
        v-model="selected"
        :adapter="adapter"
        :headers="headers"
        :needToUpdateTable="needToUpdateTable"
        show-select
        :row-class="checkIsOverdue"
      )
        template(#value--status="{ item }")
          v-chip(small label :color="statusColor(item.status)")
            template(v-if="isConsultating(item)") Ожидает консультации
            template(v-else) {{ CLIENT_QUESTION_STATUS_TEXT[item.status] }}
        template(#value--view="{ item }")
          router-link(:to="`/application/${item.id}`")
            v-icon(color="primary" small) mdi-eye
        template(#value--status="{ item }")

          v-chip(small label :color="statusColor(item.status)")
            template(v-if="isConsultating(item)") Ожидает консультации
            template(v-else) {{ CLIENT_QUESTION_STATUS_TEXT[item.status] }}
    v-card-actions
      v-btn(color="success" @click="acceptChanges" v-if="selected.length > 0") Принять изменения
      v-btn(color="error" @click="closeDialog") Закрыть
</template>
<script>
import { CLIENT_QUESTION_STATUS, CLIENT_QUESTION_STATUS_TEXT } from '../../../constants';
import groupServices from '@/services/API/client-question-groups';
import smartTable from '@/components/SmartTable/index.vue';
import { CACHE_KEYS } from '@/store/modules/cache';
import { mapActions, mapGetters } from 'vuex';
import clientQuestionService from '@/services/API/client-questions';

export default {
  components: {
    smartTable,
  },
  props: {
    group: { type: [Object], required: true },
    value: { type: Boolean, required: true },
  },
  data() {
    return {
      needToUpdateTable: true,
      dialog: false,
      selected: [],
      CLIENT_QUESTION_STATUS_TEXT,
      headers: [
        {
          text: '',
          value: 'view',
        },
        {
          text: 'Номер заявки',
          value: 'id',
          sortable: true,
          searchable: true,
        },
        {
          text: 'Название проблемы',
          value: 'text',
          sortable: true,
          searchable: true,
        },
        {
          text: 'Дата заявки',
          value: 'created_at',
          sortable: true,
        },
        {
          text: 'Статус',
          sortable: true,
          value: 'status',
          searchable: true,
        },
        // {
        //   text: 'Процесс выполнения',
        //   sortable: true,
        //   value: 'todo_lists_status',
        //   align:'center',
        // },
        {
          text: 'Почта отправителя',
          sortable: true,
          value: 'email',
          searchable: true,
        },
        { text: 'Муниципалитет', value: 'municipality_id', sortable: true },
        // { text: 'Роль пользователя', value: 'role',          sortable:true },
        // { text: 'Регион', value: 'region',          sortable:true },
        { text: 'Проект', value: 'project_id', sortable: true },
        // { text: 'Тип проблемы', value: 'type_problem',          sortable:true },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        if (v && this.data) {
          this.form  = this.data;
          this.needToUpdateTable = true;
        }
        this.needToUpdateTable = true;
        this.dialog  = v;
      },
    },
  },
  methods: {
    ...mapActions({
      'loadToCache':'cache/loadToCache',
    }),
    isConsultating({ status, current_transfer }) {
      return status === CLIENT_QUESTION_STATUS.AWAITING && current_transfer?.owner_id === this.user.id;
    },
    statusColor(status) {
      return {
        [CLIENT_QUESTION_STATUS.PENDING]: 'error',
        [CLIENT_QUESTION_STATUS.ACCEPTED]: 'primary',
        [CLIENT_QUESTION_STATUS.ANSWERED]: 'success',
        [CLIENT_QUESTION_STATUS.CLOSED]: 'secondary',
        [CLIENT_QUESTION_STATUS.AWAITING]: 'accent',
      }[status];
    },
    async adapter({ _update, ...options }) {
      const params = {
        'sort': '-id',
        'expand': 'todo_lists_status,current_transfer',
        ...options,
      };
      this.needToUpdateTable = false;
      this.updateTable = _update;
      // const groupsQuestion = this.group.client_questions.map(({ id }) => id);
      const response = await clientQuestionService.getAll(params);
      // response = response.filter(({ id }) => groupsQuestion.include(id));
      // this.selected = response.data.data.map(({ id }) => id);
      this.selected = this.group.client_questions.map(({ id }) => id);

      const municipality_ids = response.data.data.map(({ municipality_id }) => municipality_id);
      await this.loadToCache({ key: CACHE_KEYS.municipalities, ids: municipality_ids });

      const project_ids = response.data.data.map(({ project_id }) => project_id);
      await this.loadToCache({ key: CACHE_KEYS.projects, ids:  project_ids });
      return new Promise((resolve) => resolve(response));
    },
    closeDialog() {
      this.selected = [];
      this.dialog = false;
      this.$emit('close', false);
    },
    async acceptChanges() {
      const data = this.group.client_questions.map(({ id }) => id);
      const add = this.selected.filter((val) => !data.includes(val));
      const del = data.filter((val) => !this.selected.includes(val));
      if (add.length) await this.addGroup(add);
      if (del.length) await this.delGroup(del);
      this.$emit('success');
      this.$toast.success('Изменения вступили в силу');
      this.closeDialog();
    },
    async addGroup(id) {
      const params = {
        'client_question_ids': id,
      };
      try {
        await groupServices.attach(this.group.id, params);
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async delGroup(id) {
      const params = {
        'client_question_ids': id,
      };
      try {
        await groupServices.detach(this.group.id, params);
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
  },
};
</script>
<style scoped/>
